/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Modal_TitleInputs */

const he_auth_modal_title = /** @type {(inputs: Auth_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברו כדי להמשיך`)
};

const en_auth_modal_title = /** @type {(inputs: Auth_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to continue`)
};

/**
* | output |
* | --- |
* | "Sign in to continue" |
*
* @param {Auth_Modal_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_modal_title = /** @type {((inputs?: Auth_Modal_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Modal_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_modal_title(inputs)
	return en_auth_modal_title(inputs)
});